// Alternative names for countries
const COUNTRY_NAME_MAPPING = {
  'United States': 'United States of America',
  'USA': 'United States of America',
  'US': 'United States of America',
  'UK': 'United Kingdom',
  'Britain': 'United Kingdom',
  'England': 'United Kingdom',
  'Scotland': 'United Kingdom',
  'Wales': 'United Kingdom',
  'Northern Ireland': 'United Kingdom',
};

const US_STATE_MAPPING = {
  // Alabama
  'AL': 'Alabama',
  'Ala': 'Alabama',
  
  // Alaska
  'AK': 'Alaska',
  
  // Arizona
  'AZ': 'Arizona',
  'Ariz': 'Arizona',
  
  // Arkansas
  'AR': 'Arkansas',
  'Ark': 'Arkansas',
  
  // California
  'CA': 'California',
  'Calif': 'California',
  'Cal': 'California',
  
  // Colorado
  'CO': 'Colorado',
  'Colo': 'Colorado',
  
  // Connecticut
  'CT': 'Connecticut',
  'Conn': 'Connecticut',
  
  // Delaware
  'DE': 'Delaware',
  'Del': 'Delaware',
  
  // Florida
  'FL': 'Florida',
  'Fla': 'Florida',
  
  // Georgia
  'GA': 'Georgia',
  
  // Hawaii
  'HI': 'Hawaii',
  
  // Idaho
  'ID': 'Idaho',
  
  // Illinois
  'IL': 'Illinois',
  'Ill': 'Illinois',
  
  // Indiana
  'IN': 'Indiana',
  'Ind': 'Indiana',
  
  // Iowa
  'IA': 'Iowa',
  
  // Kansas
  'KS': 'Kansas',
  'Kan': 'Kansas',
  'Kans': 'Kansas',
  
  // Kentucky
  'KY': 'Kentucky',
  'Ky': 'Kentucky',
  
  // Louisiana
  'LA': 'Louisiana',
  
  // Maine
  'ME': 'Maine',
  
  // Maryland
  'MD': 'Maryland',
  
  // Massachusetts
  'MA': 'Massachusetts',
  'Mass': 'Massachusetts',
  
  // Michigan
  'MI': 'Michigan',
  'Mich': 'Michigan',
  
  // Minnesota
  'MN': 'Minnesota',
  'Minn': 'Minnesota',
  
  // Mississippi
  'MS': 'Mississippi',
  'Miss': 'Mississippi',
  
  // Missouri
  'MO': 'Missouri',
  
  // Montana
  'MT': 'Montana',
  'Mont': 'Montana',
  
  // Nebraska
  'NE': 'Nebraska',
  'Neb': 'Nebraska',
  'Nebr': 'Nebraska',
  
  // Nevada
  'NV': 'Nevada',
  'Nev': 'Nevada',
  
  // New Hampshire
  'NH': 'New Hampshire',
  'N.H.': 'New Hampshire',
  
  // New Jersey
  'NJ': 'New Jersey',
  'N.J.': 'New Jersey',
  
  // New Mexico
  'NM': 'New Mexico',
  'N.M.': 'New Mexico',
  'N. Mex': 'New Mexico',
  
  // New York
  'NY': 'New York',
  'N.Y.': 'New York',
  
  // North Carolina
  'NC': 'North Carolina',
  'N.C.': 'North Carolina',
  'N. Carolina': 'North Carolina',
  
  // North Dakota
  'ND': 'North Dakota',
  'N.D.': 'North Dakota',
  'N. Dakota': 'North Dakota',
  
  // Ohio
  'OH': 'Ohio',
  
  // Oklahoma
  'OK': 'Oklahoma',
  'Okla': 'Oklahoma',
  
  // Oregon
  'OR': 'Oregon',
  'Ore': 'Oregon',
  'Oreg': 'Oregon',
  
  // Pennsylvania
  'PA': 'Pennsylvania',
  'Penn': 'Pennsylvania',
  'Penna': 'Pennsylvania',
  
  // Rhode Island
  'RI': 'Rhode Island',
  'R.I.': 'Rhode Island',
  
  // South Carolina
  'SC': 'South Carolina',
  'S.C.': 'South Carolina',
  'S. Carolina': 'South Carolina',
  
  // South Dakota
  'SD': 'South Dakota',
  'S.D.': 'South Dakota',
  'S. Dakota': 'South Dakota',
  
  // Tennessee
  'TN': 'Tennessee',
  'Tenn': 'Tennessee',
  
  // Texas
  'TX': 'Texas',
  'Tex': 'Texas',
  
  // Utah
  'UT': 'Utah',
  
  // Vermont
  'VT': 'Vermont',
  
  // Virginia
  'VA': 'Virginia',
  'Va': 'Virginia',
  
  // Washington
  'WA': 'Washington',
  'Wash': 'Washington',
  'Washington State': 'Washington',
  
  // West Virginia
  'WV': 'West Virginia',
  'W.V.': 'West Virginia',
  'W. Virginia': 'West Virginia',
  'W Virginia': 'West Virginia',
  'W. Va': 'West Virginia',
  
  // Wisconsin
  'WI': 'Wisconsin',
  'Wis': 'Wisconsin',
  'Wisc': 'Wisconsin',
  
  // Wyoming
  'WY': 'Wyoming',
  'Wyo': 'Wyoming',
  
  // Federal District
  'DC': 'District of Columbia',
  'D.C.': 'District of Columbia',
  'Washington D.C.': 'District of Columbia',
  'Washington DC': 'District of Columbia',
  'Washington, D.C.': 'District of Columbia',
  
  // US Territories (if needed)
  'PR': 'Puerto Rico',
  'VI': 'Virgin Islands',
  'GU': 'Guam',
  'AS': 'American Samoa',
  'MP': 'Northern Mariana Islands',
  'USVI': 'Virgin Islands',
  'U.S. Virgin Islands': 'Virgin Islands'
};

module.exports = {
    COUNTRY_NAME_MAPPING,
    US_STATE_MAPPING
}